(() => {
  const storageKey = 'lvc_recent_searches';

  const readSearches = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter(Boolean).slice(0, 6) : [];
    } catch (e) {
      return [];
    }
  };

  const saveSearch = (term) => {
    const clean = String(term || '').replace(/\s+/g, ' ').trim();
    if (clean.length < 2) return;
    const next = [clean, ...readSearches().filter((item) => item.toLowerCase() !== clean.toLowerCase())].slice(0, 6);
    try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch (e) {}
  };

  const renderRecentSearches = (root) => {
    const section = root.querySelector('[data-lvc-search-recent-searches]');
    const list = root.querySelector('[data-lvc-recent-search-list]');
    if (!section || !list) return;
    const terms = readSearches();
    if (!terms.length) {
      section.hidden = true;
      list.innerHTML = '';
      return;
    }
    const base = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
    list.innerHTML = terms.map((term) => {
      const href = base + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
      return '<a href="' + href + '">' + term.replace(/[<>&"']/g, '') + '</a>';
    }).join('');
    section.hidden = false;
  };

  const setDiscovery = (root, forceShow = false) => {
    const input = root.querySelector('input[type="search"]');
    const discovery = root.querySelector('[data-lvc-search-discovery]');
    if (!input || !discovery) return;
    const show = forceShow || input === document.activeElement;
    discovery.hidden = !(show && input.value.trim().length < 2);
    if (!discovery.hidden) renderRecentSearches(root);
  };

  const bindRoot = (root) => {
    if (!root || root.dataset.lvcSearchReady === '1') return;
    root.dataset.lvcSearchReady = '1';
    const input = root.querySelector('input[type="search"]');
    const form = input?.closest('form');
    if (!input) return;

    input.addEventListener('focus', () => setDiscovery(root, true));
    input.addEventListener('input', () => setDiscovery(root, true));
    input.addEventListener('blur', () => setTimeout(() => setDiscovery(root, false), 160));
    form?.addEventListener('submit', () => saveSearch(input.value));

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-lvc-clear-searches]')) {
        try { localStorage.removeItem(storageKey); } catch (e) {}
        renderRecentSearches(root);
        input.focus();
        return;
      }
      if (event.target.closest('.predictive-search__item__product')) saveSearch(input.value);
    });
  };

  const focusModal = () => {
    const root = document.querySelector('#header-modal-search');
    const input = root?.querySelector('input[type="search"]');
    if (!input) return;
    requestAnimationFrame(() => setTimeout(() => {
      input.focus({ preventScroll: true });
      try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
      setDiscovery(root, true);
    }, 40));
  };

  const init = () => {
    document.querySelectorAll('.lvc-search-root').forEach(bindRoot);
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-modal="#header-modal-search"]')) focusModal();
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();